export function getVerificationStages(steps) {
    return {
        data: steps.some(function (step) { return step.type === 'FORM'; }),
        document: steps.some(function (step) {
            var _a;
            return step.type === 'IMAGE' ||
                (step.type === 'DECISION' && ((_a = step.fields) === null || _a === void 0 ? void 0 : _a.some(function (field) { return field.field.includes('identification_document'); })));
        }),
        selfie: steps.some(function (step) { return step.type.startsWith('LIVENESS') || step.type === 'SELFIE'; }),
    };
}
